import { render, staticRenderFns } from "./Ipf.vue?vue&type=template&id=77ce8514&"
import script from "./Ipf.vue?vue&type=script&lang=ts&"
export * from "./Ipf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports